import { render, staticRenderFns } from "./PaginationRow.vue?vue&type=template&id=3b6ecec6&scoped=true&"
import script from "./PaginationRow.vue?vue&type=script&lang=js&"
export * from "./PaginationRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6ecec6",
  null
  
)

export default component.exports